import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import classes from './svg-styles.module.sass'

const StarIcon = ({ borderColor, color, className }) => (
  <svg className={cn(classes.svg, className)} color={color} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill="currentColor" stroke={borderColor !== '' ? borderColor : 'currentColor'} d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z" />
  </svg>
)

StarIcon.defaultProps = {
  borderColor: '',
  color: '#000',
  className: '',
}

StarIcon.propTypes = {
  borderColor: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
}

export default StarIcon
